/* ==========================================================================
   Animation de chargement AUTOMATIQUE des liens-boutons (2026-09-26)
   ==========================================================================
   Regle de Ganael : tout bouton principal montre le spinner quand on clique
   dessus. Plutot que de le poser bouton par bouton (et de l'oublier sur le
   prochain), ce script le fait pour TOUS les liens <a class="btn">, presents
   et futurs, par delegation sur le document.

   Qui est concerne :
   - tout <a class="btn">, bouton plein du theme ;
   - tout <a data-cta-charge>, pour un lien qui n'a pas la classe .btn.
   Qui ne l'est PAS (delibere, voir le skill ShopifyMLS) :
   - les boutons a contour : .btn--secondary, .btn_border (filtres, navigation) ;
   - .pagination__item ;
   - tout element portant data-sans-charge.
   Les <button> ne sont pas touches : ajout au panier, tiroirs et formulaires
   ont deja leur propre attente, geree par leur script.

   Le clic est ignore quand il ne change pas la page : nouvel onglet (Ctrl,
   Cmd, Maj, molette), target=_blank, lien d'ancre, telechargement, ou clic
   deja intercepte par un autre script (defaultPrevented).
   ========================================================================== */
(function () {
  var SVG = '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" width="20" height="20" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
  var EXCLUS = '.btn--secondary, .btn_border, .pagination__item, [data-sans-charge]';

  function changePage(a, e) {
    if (e.defaultPrevented) return false;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return false;
    /* meme page, seule l'ancre change : pas de navigation */
    if (a.pathname === location.pathname && a.search === location.search && a.hash) return false;
    return true;
  }

  /* .btn.loading et .cta-charge masquent les ENFANTS par visibility : un
     texte nu resterait visible par-dessus le spinner. On l'enveloppe. */
  function envelopperTexte(a) {
    Array.prototype.slice.call(a.childNodes).forEach(function (n) {
      if (n.nodeType === 3 && n.textContent.trim() !== '') {
        var s = document.createElement('span');
        a.insertBefore(s, n);
        s.appendChild(n);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.btn, a[data-cta-charge]');
    if (!a || a.matches(EXCLUS)) return;
    if (!changePage(a, e)) return;
    envelopperTexte(a);
    if (a.classList.contains('btn')) {
      var sp = a.querySelector('.loading-overlay__spinner');
      if (!sp) {
        sp = document.createElement('div');
        sp.className = 'loading-overlay__spinner';
        sp.innerHTML = SVG;
        a.appendChild(sp);
      }
      sp.classList.remove('hidden');
      a.classList.add('loading');
    } else {
      if (!a.querySelector('.cta-charge__spin')) {
        var s = document.createElement('span');
        s.className = 'cta-charge__spin';
        s.setAttribute('aria-hidden', 'true');
        s.innerHTML = SVG;
        a.appendChild(s);
      }
      a.classList.add('cta-charge');
    }
    a.setAttribute('aria-busy', 'true');
  });

  /* Retour arriere : le navigateur peut restituer la page telle qu'on l'a
     quittee, bouton en chargement compris. */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('a.loading, a.cta-charge').forEach(function (a) {
      a.classList.remove('loading', 'cta-charge');
      a.removeAttribute('aria-busy');
      var sp = a.querySelector('.loading-overlay__spinner');
      if (sp) sp.classList.add('hidden');
    });
  });
})();
